module.exports = __webpack_public_path__ + "img/blog_03-755x505.bc5b62ae.jpg";